<template>
  <div class="quick-submit-page">
    <common-header />
    <div class="padding-bottom-30">
      <section class="submit-panel bg-white">
        <div class="panel-left bg-white">
          <!-- <div
            class="padding-bottom-20"
            style=""
            v-if="userInfo.is_member == false"
          >
            <div class="text-main text-bold">
              剩余投稿次数 {{ userInfo.submission_count }}
            </div>
            <span class="text-14" style="padding-top: 10px"
              >快去会员中心开通属于您的专属会员权益吧！</span
            >
          </div> -->
          <el-form
            :model="form"
            label-width="120px"
            size="medium"
            class="submit-form"
          >
            <el-form-item label="作品文件：">
              <el-upload
                class="upload-field"
                action="#"
                :auto-upload="false"
                :file-list="fileList"
                :show-file-list="true"
                :on-remove="handleFileRemove"
                :on-change="handleFileChange"
                :on-exceed="handleFileExceed"
                :disabled="uploading"
                :limit="1"
              >
                <template #trigger>
                  <div class="">
                    <div
                      class="upload-display w-110 h-43 flex align-center radius-8 justify-center"
                    >
                      <img src="@/assets/images/icon4.png" class="w-18 h-15" />
                      <span class="text-000-color text-12">{{
                        uploading ? "上传中..." : "上传文件"
                      }}</span>
                    </div>
                    <div class="text-14 text-999-color">
                      仅支持文档类型（如：doc、docx、pdf、txt、xls、xlsx、ppt、pptx等）
                    </div>
                  </div>
                </template>
              </el-upload>
            </el-form-item>

            <el-form-item label="作品名称：">
              <el-input
                v-model="form.name"
                placeholder="请输入作品名称，无需加《》"
              />
            </el-form-item>

            <el-form-item label="作品字数：">
              <el-select v-model="form.words" placeholder="请选择作品字数">
                <el-option
                  v-for="item in wordOptions"
                  :key="item.id || item.name"
                  :label="item.name || item"
                  :value="item.name || item"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="作品分类：">
              <el-select v-model="form.category" placeholder="请选择">
                <el-option
                  v-for="item in categories"
                  :key="item.id || item.name"
                  :label="item.name || item"
                  :value="item.name || item"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="读者分类：">
              <el-select v-model="form.readerCategory" placeholder="请选择">
                <el-option
                  v-for="item in readerCategories"
                  :key="item.id || item.name"
                  :label="item.name || item"
                  :value="item.name || item"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="读者情绪：">
              <el-select v-model="form.readerEmotion" placeholder="请选择">
                <el-option
                  v-for="item in readerEmotions"
                  :key="item.id || item.name"
                  :label="item.name || item"
                  :value="item.name || item"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="作品风格：">
              <el-select v-model="form.style" placeholder="请选择">
                <el-option
                  v-for="item in styles"
                  :key="item.id || item.name"
                  :label="item.name || item"
                  :value="item.name || item"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="作品类型（多选）：">
              <div class="tag-list">
                <span
                  v-for="tag in workTags"
                  :key="tag.id || tag.name || tag"
                  class="tag-pill text-14 radius-20"
                  :class="{
                    active: form.tags.some(
                      (item) =>
                        (typeof item === 'object' &&
                          typeof tag === 'object' &&
                          item.id === tag.id) ||
                        item === tag
                    ),
                  }"
                  @click="toggleTag(tag)"
                >
                  {{ tag.name || tag }}
                </span>
              </div>
            </el-form-item>

            <el-form-item label="作品邮件：">
              <el-input
                type="textarea"
                :rows="6"
                v-model="form.description"
                placeholder="邮件正文可不填，如需要请自行填写：作品分类、字数、笔名、过往成绩等。"
              />
            </el-form-item>
          </el-form>
        </div>

        <div class="platform-container">
          <div class="platform-header justify-between">
            <div class="flex align-center">
              <span>平台：</span>
              <el-input
                placeholder="输入关键词，筛选意向平台"
                size="small"
                v-model="platformKeyword"
                @keyup.enter.native="handlePlatformSearch"
              />
              <span class="text-14 text-000 padding-left-10"
                >已选：{{
                  selectedPlatformEmailsCount +
                  selectedFavoritesCount +
                  selectedAddressBooksCount
                }}
                个</span
              >
            </div>

            <div
              class="text-main text-bold draft-entry-link"
              @click="HistoricalSubmissions"
            >
              草稿箱
            </div>
          </div>

          <div class="platform-favorites-container">
            <div class="platform-list">
              <el-tree
                :data="treeData"
                :props="treeProps"
                node-key="id"
                :default-expand-all="true"
                :expand-on-click-node="false"
                @node-click="handleNodeClick"
                ref="platformTree"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span class="tree-node-content">
                    <img
                      v-if="data.type === 'email'"
                      :src="
                        isPlatformEmailNodeSelected(data.platformId, data.id)
                          ? iconChecked
                          : iconUnchecked
                      "
                      alt="checkbox"
                      class="w-18 h-18"
                    />
                    <el-tooltip
                      :content="`${node.label}${
                        data.type === 'email' && data.emailData?.email
                          ? ' (' + data.emailData.email + ')'
                          : ''
                      }`"
                      placement="top"
                      :open-delay="300"
                    >
                      <span class="tree-node-label">
                        {{ node.label
                        }}<span
                          v-if="data.type === 'email' && data.emailData?.email"
                        >
                          ({{ data.emailData.email }})</span
                        >
                      </span>
                    </el-tooltip>
                  </span>
                  <span
                    v-if="data.type === 'email'"
                    class="favorite-btn"
                    @click.stop="toggleFavorite(data)"
                    :title="
                      isFavorite(data.emailData?.id) ? '取消收藏' : '添加收藏'
                    "
                  >
                    <i
                      :class="
                        isFavorite(data.emailData?.id)
                          ? 'el-icon-star-on'
                          : 'el-icon-star-off'
                      "
                      class="favorite-icon"
                    ></i>
                  </span>
                </span>
              </el-tree>
            </div>

            <div class="favorites-address-column">
              <div class="favorites-list">
                <div class="favorites-header">收藏列表</div>
                <div class="favorites-content" @scroll="handleFavoritesScroll">
                  <el-tooltip
                    v-for="item in favoritesList"
                    :key="item.id"
                    :content="`${item.editor_name}${
                      item.email ? ' (' + item.email + ')' : ''
                    }`"
                    placement="top"
                    :open-delay="500"
                  >
                    <div
                      class="favorite-item"
                      :class="{
                        active:
                          selectedFavorites[item.id] ||
                          selectedFavorites[item.platform_email_id],
                      }"
                      @click="handleFavoriteClick(item)"
                    >
                      <div class="favorite-item-content">
                        <img
                          :src="
                            selectedFavorites[item.id] ||
                            selectedFavorites[item.platform_email_id]
                              ? iconChecked
                              : iconUnchecked
                          "
                          alt="checkbox"
                          class="w-18 h-18"
                        />
                        <span
                          >{{ item.editor_name
                          }}<span v-if="item.email">
                            ({{ item.email }})</span
                          ></span
                        >
                      </div>
                      <span
                        class="favorite-delete-btn"
                        @click.stop="removeFavorite(item)"
                        title="删除收藏"
                      >
                        <i class="el-icon-delete delete-icon"></i>
                      </span>
                    </div>
                  </el-tooltip>
                  <div
                    v-if="favoritesList.length === 0 && !favoritesLoading"
                    class="empty-favorites"
                  >
                    暂无收藏
                  </div>
                  <div v-if="favoritesLoading" class="loading-favorites">
                    <i class="el-icon-loading"></i> 加载中...
                  </div>
                  <div
                    v-if="
                      favoritesList.length > 0 &&
                      !favoritesHasMore &&
                      !favoritesLoading
                    "
                    class="no-more-favorites"
                  >
                    没有更多了
                  </div>
                </div>
              </div>

              <div class="address-book-list">
                <div class="address-book-header">通讯录</div>
                <div
                  class="address-book-content"
                  @scroll="handleAddressBookScroll"
                >
                  <el-tooltip
                    v-for="item in addressBookList"
                    :key="item.id"
                    :content="`${item.name}${
                      item.email ? ' (' + item.email + ')' : ''
                    }`"
                    placement="top"
                    :open-delay="500"
                  >
                    <div
                      class="address-book-item"
                      :class="{
                        active: selectedAddressBooks[item.id],
                      }"
                      @click="handleAddressBookClick(item)"
                    >
                      <div class="address-book-item-content">
                        <img
                          :src="
                            selectedAddressBooks[item.id]
                              ? iconChecked
                              : iconUnchecked
                          "
                          alt="checkbox"
                          class="w-18 h-18"
                        />
                        <span
                          >{{ item.name
                          }}<span v-if="item.email">
                            ({{ item.email }})</span
                          ></span
                        >
                      </div>
                    </div>
                  </el-tooltip>
                  <div
                    v-if="addressBookList.length === 0 && !addressBookLoading"
                    class="empty-address-book"
                  >
                    暂无通讯录
                  </div>
                  <div v-if="addressBookLoading" class="loading-address-book">
                    <i class="el-icon-loading"></i> 加载中...
                  </div>
                  <div
                    v-if="
                      addressBookList.length > 0 &&
                      !addressBookHasMore &&
                      !addressBookLoading
                    "
                    class="no-more-address-book"
                  >
                    没有更多了
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="submit-footer">
        <el-button
          type="primary"
          round
          size="medium"
          :loading="saveLoading"
          @click="handleSave"
        >
          保存草稿箱
        </el-button>
      </footer>
    </div>

    <!-- 授权邮箱弹窗 -->
    <el-dialog
      :visible.sync="emailAuthDialogVisible"
      width="800px"
      custom-class="email-auth-dialog"
      :show-close="false"
      :close-on-click-modal="true"
    >
      <template #title>
        <div class="email-auth-title text-center text-bold">授权邮箱</div>
      </template>
      <div class="email-auth-content">
        <div class="email-auth-form flex justify-between">
          <!-- 邮箱选择 -->
          <div class="email-auth-field flex align-center">
            <label class="email-auth-label padding-right-4">邮箱</label>
            <el-input
              v-model="emailAuthForm.email"
              placeholder=""
              class="email-auth-input"
              :disabled="true"
            >
            </el-input>
          </div>
          <!-- 授权码输入 -->
          <div class="email-auth-field flex align-center">
            <label class="email-auth-label padding-right-4">授权码</label>
            <el-input
              v-model="emailAuthForm.authCode"
              placeholder="请输入授权码"
              class="email-auth-input"
            >
            </el-input>
          </div>
          <!-- 笔名输入 -->
          <div class="email-auth-field flex align-center">
            <label class="email-auth-label padding-right-4">笔名</label>
            <el-input
              v-model="emailAuthForm.penName"
              placeholder="请输入笔名"
              class="email-auth-input"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div slot="footer" class="email-auth-footer text-center">
        <div
          class="text-14 padding-bottom-20 text-main"
          @click="handleEmailAuthorizationCodeTutorial"
        >
          获取邮箱授权码教程
        </div>
        <el-button
          class="email-auth-save-btn"
          :loading="emailAuthLoading"
          @click="handleEmailAuthSave"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue";
import {
  getWords,
  getWorkType,
  getWorkCategory,
  getReaderCategory,
  getReaderEmotion,
  getWorkStyle,
  getPlatformMatch,
  getFavoriteEditorList,
  addFavoriteEditor,
  deleteFavoriteEditor,
  getAddressBookList,
} from "@/api/dictionary";
import {
  addSubmission,
  editSubmission,
  getSubmissionDetail,
} from "@/api/submission";
import { uploadFile } from "@/api/common";
import { getUserInfo, changeEmailCode } from "@/api/user";

export default {
  name: "QuickSubmit",
  components: { CommonHeader },
  data() {
    return {
      fileList: [],
      wordOptions: [],
      categories: [],
      readerCategories: [],
      readerEmotions: [],
      styles: [],
      workTags: [],
      platformKeyword: "",
      selectedPlatforms: [],
      // 每个平台选中的邮箱节点 ID 列表，格式：{ platformId: ['email_1_..', ...] }，支持同平台多选
      selectedEmailsByPlatform: {},
      selectedFavorites: {}, // 选中的收藏项，格式：{ favoriteId: true }
      selectedAddressBooks: {}, // 选中的通讯录项，格式：{ addressBookId: true }
      iconChecked: require("@/assets/images/icon6.png"),
      iconUnchecked: require("@/assets/images/icon5.png"),
      platforms: [],
      treeData: [], // 树形数据
      treeProps: {
        children: "children",
        label: "label",
      },
      favoritesList: [], // 收藏列表数据
      favoritesPage: 1, // 收藏列表当前页码
      favoritesLimit: 20, // 每页加载数量
      favoritesHasMore: true, // 是否还有更多数据
      favoritesLoading: false, // 收藏列表加载状态
      addressBookList: [], // 通讯录列表数据
      addressBookPage: 1, // 通讯录当前页码
      addressBookLimit: 20, // 每页加载数量
      addressBookHasMore: true, // 是否还有更多数据
      addressBookLoading: false, // 通讯录加载状态
      form: {
        name: "",
        words: "",
        category: "",
        readerCategory: "",
        readerEmotion: "",
        style: "",
        tags: [],
        description: "",
      },
      loading: false,
      saveLoading: false, // 保存按钮加载状态
      uploadedFiles: [], // 上传后的文件信息数组
      uploading: false, // 文件上传中状态
      // 授权邮箱弹窗相关
      emailAuthDialogVisible: false,
      emailAuthLoading: false,
      filteredPlatforms: [],
      emailAuthForm: {
        email: "",
        authCode: "",
        penName: "",
      },
      emailList: [
        { label: "163.com", value: "163" },
        { label: "qq.com", value: "qq" },
        { label: "gmail.com", value: "gmail" },
        { label: "sina.com", value: "sina" },
      ],
      userInfo: {}, // 用户信息
    };
  },
  computed: {
    // 左侧平台树已选的邮箱节点总数（每平台单选）
    selectedPlatformEmailsCount() {
      return Object.keys(this.selectedEmailsByPlatform).length;
    },
    // 选中的收藏数量（去重：id 与 platform_email_id 可能指向同一项）
    selectedFavoritesCount() {
      return this.favoritesList.filter(
        (item) =>
          this.selectedFavorites[item.id] ||
          this.selectedFavorites[item.platform_email_id]
      ).length;
    },
    // 选中的通讯录数量
    selectedAddressBooksCount() {
      return this.addressBookList.filter(
        (item) => this.selectedAddressBooks[item.id]
      ).length;
    },
  },
  mounted() {
    this.fetchUserInfo();
    this.loadFavorites(); // 加载收藏列表
    this.loadAddressBook(); // 加载通讯录

    // 先加载所有字典数据（不包括平台列表，平台列表通过 watch 触发查询）
    Promise.all([
      this.fetchWords(),
      this.fetchWorkType(),
      this.fetchWorkCategory(),
      this.fetchReaderCategory(),
      this.fetchReaderEmotion(),
      this.fetchWorkStyle(),
    ]).then(() => {
      // 检查是否有编辑ID参数
      const id = this.$route.query.id;
      if (id) {
        // 字典数据加载完成后再获取详情并填充表单
        this.fetchSubmissionDetail(id);
      }
    });
  },
  methods: {
    // 获取用户信息
    fetchUserInfo() {
      getUserInfo()
        .then((response) => {
          if (response.data) {
            this.userInfo = response.data;
            this.emailAuthForm.email = response.data.email;
          }
        })
        .catch((error) => {
          // 401 错误已经在拦截器中处理了跳转，这里只处理其他错误
          if (error.message && !error.message.includes("请登录后操作")) {
            console.error("获取用户信息失败:", error);
          }
        });
    },
    handleEmailAuthorizationCodeTutorial() {
      // 跳转到授权教程页面
      if (this.$router) {
        this.$router.push("/email-auth-tutorial");
      }
    },
    // 获取作品字数列表
    fetchWords() {
      return getWords().then((response) => {
        this.wordOptions = response.data;
      });
    },
    // 获取作品类型列表
    fetchWorkType() {
      return getWorkType().then((response) => {
        this.workTags = response.data;
      });
    },
    // 获取作品分类列表
    fetchWorkCategory() {
      return getWorkCategory().then((response) => {
        this.categories = response.data;
      });
    },
    // 获取读者分类列表
    fetchReaderCategory() {
      return getReaderCategory().then((response) => {
        this.readerCategories = response.data;
      });
    },
    // 获取读者情绪列表
    fetchReaderEmotion() {
      return getReaderEmotion().then((response) => {
        this.readerEmotions = response.data;
      });
    },
    // 获取作品风格列表
    fetchWorkStyle() {
      return getWorkStyle().then((response) => {
        this.styles = response.data;
      });
    },
    // 根据表单字段获取平台匹配列表（须同时选择作品字数与作品分类后才请求编辑匹配）
    // shouldReselect 为 true 时，按“收藏优先/否则随机”重新分配每个平台选中邮箱
    fetchPlatformMatch(shouldReselect = false) {
      const wordItem = this.wordOptions.find(
        (item) => (item.name || item) === this.form.words
      );
      const categoryItem = this.categories.find(
        (item) => (item.name || item) === this.form.category
      );
      const hasWordCount = !!(wordItem && wordItem.id);
      const hasWorkCategory = !!(categoryItem && categoryItem.id);

      if (!hasWordCount || !hasWorkCategory) {
        this.platforms = [];
        this.filteredPlatforms = [];
        this.treeData = [];
        this.$nextTick(() => {
          this.syncFavoritePanelWithQueriedEditors();
        });
        return Promise.resolve();
      }

      // 构建查询参数（字数、分类已保证存在）
      const params = {
        word_count_id: wordItem.id,
        work_category_ids: categoryItem.id,
      };

      // 读者分类ID
      const readerCategoryItem = this.readerCategories.find(
        (item) => (item.name || item) === this.form.readerCategory
      );
      if (readerCategoryItem && readerCategoryItem.id) {
        params.reader_category_ids = readerCategoryItem.id;
      }

      // 读者情绪ID
      const readerEmotionItem = this.readerEmotions.find(
        (item) => (item.name || item) === this.form.readerEmotion
      );
      if (readerEmotionItem && readerEmotionItem.id) {
        params.reader_emotion_ids = readerEmotionItem.id;
      }

      // 作品风格ID
      const styleItem = this.styles.find(
        (item) => (item.name || item) === this.form.style
      );
      if (styleItem && styleItem.id) {
        params.work_style_ids = styleItem.id;
      }

      // 作品类型ID数组
      if (this.form.tags.length > 0) {
        const workTypeIds = this.form.tags
          .map((tag) => {
            const tagItem =
              typeof tag === "object"
                ? tag
                : this.workTags.find(
                    (item) => item === tag || (item.name || item) === tag
                  );
            return tagItem && tagItem.id ? tagItem.id : null;
          })
          .filter((id) => id !== null);
        if (workTypeIds.length > 0) {
          params.work_type_ids = workTypeIds.join(",");
        }
      }

      return getPlatformMatch(params)
        .then((response) => {
          this.platforms = response.data || [];
          this.filteredPlatforms = response.data || [];
          this.buildTreeData(shouldReselect);
        })
        .catch((error) => {
          console.error("获取平台匹配列表失败:", error);
          this.platforms = [];
          this.filteredPlatforms = [];
          this.treeData = [];
          this.$nextTick(() => {
            this.syncFavoritePanelWithQueriedEditors();
          });
        });
    },
    // 构建树形数据
    buildTreeData(shouldReselect = false) {
      this.treeData = this.filteredPlatforms.map((platform) => {
        const node = {
          id: `platform_${platform.id}`,
          label: platform.name,
          type: "platform",
          disabled: true, // 一级节点不可选
          children: [],
        };

        // 添加邮箱子节点
        if (platform.emails && Array.isArray(platform.emails)) {
          node.children = platform.emails.map((email) => ({
            id: `email_${platform.id}_${email.id || email.editor_name}`,
            label: email.editor_name,
            type: "email",
            platformId: platform.id,
            emailData: email,
          }));
        }

        return node;
      });

      if (shouldReselect) {
        this.autoSelectFirstEmails();
      } else {
        this.pruneInvalidSelections();
      }
      this.$nextTick(() => {
        this.syncFavoritePanelWithQueriedEditors();
      });
    },
    // 自动选中：有收藏则优先选其一；无收藏则随机选一个（仅新建投稿）
    autoSelectFirstEmails() {
      if (this.$route.query.id) {
        return;
      }

      // 清空之前的选择
      this.selectedEmailsByPlatform = {};

      this.filteredPlatforms.forEach((platform) => {
        if (
          !platform.emails ||
          !Array.isArray(platform.emails) ||
          platform.emails.length === 0
        ) {
          return;
        }

        const favoritedIds = new Set(
          this.favoritesList
            .filter(
              (f) =>
                f.platform_id != null &&
                String(f.platform_id) === String(platform.id)
            )
            .map((f) => f.platform_email_id)
            .filter((id) => id != null && id !== "")
            .map((id) => String(id))
        );

        const favoritedEmails = platform.emails.filter(
          (e) => e.id != null && favoritedIds.has(String(e.id))
        );
        if (favoritedEmails.length > 0) {
          const randomFavorite =
            favoritedEmails[Math.floor(Math.random() * favoritedEmails.length)];
          this.$set(
            this.selectedEmailsByPlatform,
            platform.id,
            `email_${platform.id}_${
              randomFavorite.id || randomFavorite.editor_name
            }`
          );
        } else {
          const randomIndex = Math.floor(
            Math.random() * platform.emails.length
          );
          const randomEmail = platform.emails[randomIndex];
          this.$set(
            this.selectedEmailsByPlatform,
            platform.id,
            `email_${platform.id}_${randomEmail.id || randomEmail.editor_name}`
          );
        }
      });
    },
    // 刷新平台列表后，移除无效选择；有效选择尽量保留，不做随机重选
    pruneInvalidSelections() {
      const validNodeIdsByPlatform = {};
      (this.filteredPlatforms || []).forEach((platform) => {
        const ids = new Set(
          (platform.emails || []).map(
            (email) => `email_${platform.id}_${email.id || email.editor_name}`
          )
        );
        validNodeIdsByPlatform[String(platform.id)] = ids;
      });

      const nextSelected = {};
      Object.keys(this.selectedEmailsByPlatform || {}).forEach((platformId) => {
        const selectedNodeId = this.selectedEmailsByPlatform[platformId];
        const validSet = validNodeIdsByPlatform[String(platformId)];
        if (validSet && validSet.has(selectedNodeId)) {
          nextSelected[platformId] = selectedNodeId;
        }
      });
      this.selectedEmailsByPlatform = nextSelected;
    },
    /**
     * 右侧「收藏列表」勾选与当前左侧查询结果对齐：仅当某收藏的 platform_email_id
     * 出现在本次 filteredPlatforms 的编辑列表中时才默认勾选；不在查询结果中的收藏不勾选。
     * 编辑模式以详情接口恢复的 favorite 为准，此处不覆盖。
     */
    syncFavoritePanelWithQueriedEditors() {
      if (this.$route.query.id) {
        return;
      }
      const queriedEmailIds = new Set();
      (this.filteredPlatforms || []).forEach((platform) => {
        (platform.emails || []).forEach((e) => {
          if (e.id != null) {
            queriedEmailIds.add(String(e.id));
          }
        });
      });
      this.favoritesList.forEach((item) => {
        const pid = item.platform_email_id;
        const inQuery =
          pid != null && pid !== "" && queriedEmailIds.has(String(pid));
        if (inQuery) {
          if (item.id != null) {
            this.$set(this.selectedFavorites, String(item.id), true);
          }
          this.$set(this.selectedFavorites, String(pid), true);
        } else {
          if (item.id != null) {
            this.$delete(this.selectedFavorites, String(item.id));
          }
          if (pid != null) {
            this.$delete(this.selectedFavorites, String(pid));
          }
        }
      });
    },
    /** 左侧树：某平台下该邮箱节点是否已勾选 */
    isPlatformEmailNodeSelected(platformId, emailNodeId) {
      return this.selectedEmailsByPlatform[platformId] === emailNodeId;
    },
    // 处理树节点点击（同平台内单选）
    handleNodeClick(data, node) {
      if (data.type === "email") {
        const platformId = data.platformId;
        const currentSelected = this.selectedEmailsByPlatform[platformId];
        if (currentSelected === data.id) {
          this.$delete(this.selectedEmailsByPlatform, platformId);
        } else {
          this.$set(this.selectedEmailsByPlatform, platformId, data.id);
        }
      }
    },
    // 处理收藏项点击
    handleFavoriteClick(item) {
      const favoriteId = item.id;
      const platformEmailId = item.platform_email_id;
      const isSelected =
        this.selectedFavorites[favoriteId] ||
        this.selectedFavorites[platformEmailId];

      // 切换选中状态，同时清理 id 和 platform_email_id 两个 key
      if (isSelected) {
        if (favoriteId != null)
          this.$delete(this.selectedFavorites, String(favoriteId));
        if (platformEmailId != null)
          this.$delete(this.selectedFavorites, String(platformEmailId));
      } else {
        this.$set(this.selectedFavorites, String(favoriteId), true);
      }
    },
    // 切换收藏状态
    toggleFavorite(data) {
      const isFav = this.isFavorite(data.emailData?.id);

      if (isFav) {
        // 已收藏，取消收藏
        const favoriteItem = this.favoritesList.find(
          (item) => item.platform_email_id === data.emailData?.id
        );
        if (favoriteItem) {
          this.removeFavorite(favoriteItem);
        }
      } else {
        // 未收藏，添加到收藏列表
        if (!data.emailData?.id) {
          this.$message.error("邮箱数据异常，无法收藏");
          return;
        }

        addFavoriteEditor({ platform_email_id: data.emailData.id })
          .then(() => {
            this.$message.success("已添加到收藏");
            // 重新加载收藏列表（重置分页）
            this.favoritesPage = 1;
            this.favoritesHasMore = true;
            this.loadFavorites(false);
          })
          .catch((error) => {
            this.$message.error(error.message || "收藏失败，请稍后重试");
          });
      }
    },
    // 删除收藏
    removeFavorite(item) {
      if (!item.id) {
        this.$message.error("收藏数据异常");
        return;
      }

      this.$confirm("确定要取消收藏吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteFavoriteEditor({ id: item.id })
            .then(() => {
              this.$message.success("已取消收藏");
              // 重新加载收藏列表（重置分页）
              this.favoritesPage = 1;
              this.favoritesHasMore = true;
              this.loadFavorites(false);
            })
            .catch((error) => {
              this.$message.error(error.message || "取消收藏失败，请稍后重试");
            });
        })
        .catch(() => {
          // 用户取消操作
        });
    },
    // 判断是否已收藏
    isFavorite(platformEmailId) {
      return this.favoritesList.some(
        (item) => item.platform_email_id === platformEmailId
      );
    },
    // 加载收藏列表
    loadFavorites(isLoadMore = false) {
      // 如果是加载更多，检查是否还有数据
      if (isLoadMore && !this.favoritesHasMore) {
        return;
      }

      // 防止重复加载
      if (this.favoritesLoading) {
        return;
      }

      this.favoritesLoading = true;

      const params = {
        page: isLoadMore ? this.favoritesPage : 1,
        limit: this.favoritesLimit,
      };

      getFavoriteEditorList(params)
        .then((response) => {
          this.favoritesLoading = false;

          if (
            response.data &&
            response.data.list &&
            Array.isArray(response.data.list)
          ) {
            const newList = response.data.list.map((item) => ({
              ...item,
              // 构建邮箱节点ID，用于选中状态判断
              emailId: `email_${item.platform_id}_${item.platform_email_id}`,
            }));

            if (isLoadMore) {
              // 加载更多：追加到列表
              this.favoritesList = [...this.favoritesList, ...newList];
            } else {
              // 首次加载或刷新：替换列表
              this.favoritesList = newList;
              this.favoritesPage = 1;
            }

            // 判断是否还有更多数据
            // 如果返回的数据少于limit，说明没有更多数据了
            this.favoritesHasMore = newList.length >= this.favoritesLimit;

            // 如果是加载更多且成功，页码+1
            if (isLoadMore && newList.length > 0) {
              this.favoritesPage++;
            }

            // 与平台树对齐：左侧 autoSelect；右侧仅勾选「当前查询结果 ∩ 收藏」
            this.$nextTick(() => {
              if (!isLoadMore) {
                this.autoSelectFirstEmails();
              }
              this.syncFavoritePanelWithQueriedEditors();
            });
          } else {
            if (!isLoadMore) {
              this.favoritesList = [];
            }
            this.favoritesHasMore = false;
          }
        })
        .catch((error) => {
          this.favoritesLoading = false;
          console.error("加载收藏列表失败:", error);
          if (!isLoadMore) {
            this.favoritesList = [];
          }
          this.favoritesHasMore = false;
        });
    },
    // 处理收藏列表滚动事件
    handleFavoritesScroll(event) {
      const target = event.target;
      // 判断是否滚动到底部（距离底部50px以内触发加载）
      const isBottom =
        target.scrollHeight - target.scrollTop - target.clientHeight < 50;

      if (isBottom && this.favoritesHasMore && !this.favoritesLoading) {
        this.loadFavorites(true);
      }
    },
    // 加载通讯录列表
    loadAddressBook(isLoadMore = false) {
      // 如果是加载更多，检查是否还有数据
      if (isLoadMore && !this.addressBookHasMore) {
        return;
      }

      // 防止重复加载
      if (this.addressBookLoading) {
        return;
      }

      this.addressBookLoading = true;

      const data = {
        page: isLoadMore ? this.addressBookPage : 1,
        limit: this.addressBookLimit,
      };

      getAddressBookList(data)
        .then((response) => {
          this.addressBookLoading = false;

          if (
            response.data &&
            response.data.list &&
            Array.isArray(response.data.list)
          ) {
            const newList = response.data.list;

            if (isLoadMore) {
              // 加载更多：追加到列表
              this.addressBookList = [...this.addressBookList, ...newList];
            } else {
              // 首次加载或刷新：替换列表
              this.addressBookList = newList;
              this.addressBookPage = 1;
            }

            // 判断是否还有更多数据
            this.addressBookHasMore = newList.length >= this.addressBookLimit;

            // 如果是加载更多且成功，页码+1
            if (isLoadMore && newList.length > 0) {
              this.addressBookPage++;
            }
          } else {
            if (!isLoadMore) {
              this.addressBookList = [];
            }
            this.addressBookHasMore = false;
          }
        })
        .catch((error) => {
          this.addressBookLoading = false;
          console.error("加载通讯录失败:", error);
          if (!isLoadMore) {
            this.addressBookList = [];
          }
          this.addressBookHasMore = false;
        });
    },
    // 处理通讯录列表滚动事件
    handleAddressBookScroll(event) {
      const target = event.target;
      // 判断是否滚动到底部（距离底部50px以内触发加载）
      const isBottom =
        target.scrollHeight - target.scrollTop - target.clientHeight < 50;

      if (isBottom && this.addressBookHasMore && !this.addressBookLoading) {
        this.loadAddressBook(true);
      }
    },
    // 处理通讯录项点击
    handleAddressBookClick(item) {
      const addressBookId = item.id;

      // 切换选中状态
      if (this.selectedAddressBooks[addressBookId]) {
        this.$delete(this.selectedAddressBooks, addressBookId);
      } else {
        this.$set(this.selectedAddressBooks, addressBookId, true);
      }
    },
    // 处理平台搜索（回车事件）
    handlePlatformSearch() {
      const keyword = this.platformKeyword.trim();

      if (!keyword) {
        // 如果关键词为空，显示所有平台
        this.filteredPlatforms = this.platforms;
      } else {
        // 使用关键词过滤平台列表
        const filtered = this.platforms.filter((item) => {
          const name = item.name || "";
          const email = item.email || "";
          // 同时搜索平台名称和邮箱编辑名称
          const hasEmailMatch =
            item.emails &&
            Array.isArray(item.emails) &&
            item.emails.some((e) => (e.editor_name || "").includes(keyword));
          return (
            name.includes(keyword) || email.includes(keyword) || hasEmailMatch
          );
        });

        this.filteredPlatforms = filtered;

        if (filtered.length === 0) {
          this.$message.warning("未找到匹配的平台");
        }
      }

      // 重新构建树形数据
      this.buildTreeData();
    },
    // 获取投稿详情并填充表单
    fetchSubmissionDetail(id) {
      this.loading = true;
      getSubmissionDetail(id).then((response) => {
        this.loading = false;
        if (response.data) {
          const data = response.data;
          console.log("detail favorite_list:", data.favorite_list);
          console.log("detail address_book_list:", data.address_book_list);
          // 填充基本表单数据
          this.form.name = data.title || "";
          this.form.words = data.word_count || "";
          this.form.description = data.email_body || "";

          // 填充作品分类 - 需要找到对应的选项
          if (
            data.work_category_name ||
            (data.work_category && data.work_category.name)
          ) {
            const categoryName =
              data.work_category_name || data.work_category.name;
            const categoryItem = this.categories.find(
              (item) =>
                (item.name || item) === categoryName ||
                (item.id &&
                  data.work_category_id &&
                  item.id === data.work_category_id)
            );
            if (categoryItem) {
              this.form.category = categoryItem.name || categoryItem;
            }
          }

          // 填充读者分类
          if (
            data.reader_category_name ||
            (data.reader_category && data.reader_category.name)
          ) {
            const readerCategoryName =
              data.reader_category_name || data.reader_category.name;
            const readerCategoryItem = this.readerCategories.find(
              (item) =>
                (item.name || item) === readerCategoryName ||
                (item.id &&
                  data.reader_category_id &&
                  item.id === data.reader_category_id)
            );
            if (readerCategoryItem) {
              this.form.readerCategory =
                readerCategoryItem.name || readerCategoryItem;
            }
          }

          // 填充读者情绪
          if (
            data.reader_emotion_name ||
            (data.reader_emotion && data.reader_emotion.name)
          ) {
            const readerEmotionName =
              data.reader_emotion_name || data.reader_emotion.name;
            const readerEmotionItem = this.readerEmotions.find(
              (item) =>
                (item.name || item) === readerEmotionName ||
                (item.id &&
                  data.reader_emotion_id &&
                  item.id === data.reader_emotion_id)
            );
            if (readerEmotionItem) {
              this.form.readerEmotion =
                readerEmotionItem.name || readerEmotionItem;
            }
          }

          // 填充作品风格
          if (
            data.work_style_name ||
            (data.work_style && data.work_style.name)
          ) {
            const styleName = data.work_style_name || data.work_style.name;
            const styleItem = this.styles.find(
              (item) =>
                (item.name || item) === styleName ||
                (item.id &&
                  data.work_style_id &&
                  item.id === data.work_style_id)
            );
            if (styleItem) {
              this.form.style = styleItem.name || styleItem;
            }
          }

          // 处理作品类型（tags）
          this.form.tags = [];
          if (data.work_types && Array.isArray(data.work_types)) {
            // 找到对应的标签项
            data.work_types.forEach((workType) => {
              const tagName = workType.name || workType;
              const tagItem = this.workTags.find((item) => {
                if (typeof item === "object") {
                  return item.name === tagName || item.id === workType.id;
                }
                return item === tagName;
              });
              if (tagItem) {
                this.form.tags.push(tagItem);
              }
            });
          } else if (
            data.work_type_names &&
            Array.isArray(data.work_type_names)
          ) {
            data.work_type_names.forEach((tagName) => {
              const tagItem = this.workTags.find((item) => {
                if (typeof item === "object") {
                  return item.name === tagName;
                }
                return item === tagName;
              });
              if (tagItem) {
                this.form.tags.push(tagItem);
              }
            });
          }

          // 处理收藏列表选中（编辑模式下恢复 API 返回的 favorite_list）
          // favorite_list 为数组，每项为对象 { id: xxx }，item.id 为选中项的 id
          // 兼容 favorite_editor_ids 直接为 id 数组的格式
          this.selectedFavorites = {};
          const extractFavoriteId = (item) => {
            if (!item) return null;
            if (typeof item === "object") {
              const id =
                item.id != null
                  ? item.id
                  : item.favorite_editor_id != null
                  ? item.favorite_editor_id
                  : item.favorite_id != null
                  ? item.favorite_id
                  : item.platform_email_id;
              return id;
            }
            return item;
          };
          const favoriteList =
            data.favorite_list || data.favorite_editor_list || [];
          const favoriteEditorIdsArray = Array.isArray(data.favorite_editor_ids)
            ? data.favorite_editor_ids
            : [];
          const favList = Array.isArray(favoriteList) ? favoriteList : [];
          favList.forEach((item) => {
            if (item && typeof item === "object") {
              const id = extractFavoriteId(item);
              if (id != null && id !== "") {
                this.$set(this.selectedFavorites, String(id), true);
              }
              // 详情 id 可能与收藏列表 item.id 不同，收藏列表可能用 platform_email_id
              if (
                item.platform_email_id != null &&
                item.platform_email_id !== ""
              ) {
                this.$set(
                  this.selectedFavorites,
                  String(item.platform_email_id),
                  true
                );
              }
            }
          });
          favoriteEditorIdsArray.forEach((id) => {
            if (id != null && id !== "") {
              this.$set(this.selectedFavorites, String(id), true);
            }
          });

          // 处理通讯录选中（编辑模式下恢复 API 返回的 address_book_list）
          // address_book_list 为数组，每项为对象 { id: xxx }，item.id 为选中项的 id
          // 兼容 address_book_ids 直接为 id 数组的格式
          this.selectedAddressBooks = {};
          const extractAddressBookId = (item) => {
            if (!item) return null;
            if (typeof item === "object") {
              return item.id != null ? item.id : item.address_book_id;
            }
            return item;
          };
          const addressBookList = data.address_book_list || [];
          const addressBookIdsArray = Array.isArray(data.address_book_ids)
            ? data.address_book_ids
            : [];
          const addressBookIds = [
            ...(Array.isArray(addressBookList) ? addressBookList : []).map(
              extractAddressBookId
            ),
            ...addressBookIdsArray,
          ].filter((id) => id != null && id !== "");
          addressBookIds.forEach((id) => {
            this.$set(this.selectedAddressBooks, String(id), true);
          });

          // 处理平台信息（编辑模式下恢复选中的邮箱，同平台单选）
          this.selectedPlatforms = [];
          this.selectedEmailsByPlatform = {};
          if (
            data.platforms &&
            Array.isArray(data.platforms) &&
            data.platforms.length > 0
          ) {
            const favoriteEmailSet = new Set(
              (this.favoritesList || [])
                .filter(
                  (item) =>
                    item.platform_id != null && item.platform_email_id != null
                )
                .map(
                  (item) =>
                    `${String(item.platform_id)}_${String(
                      item.platform_email_id
                    )}`
                )
            );
            data.platforms.forEach((platformData) => {
              const platformId = platformData.platform_id || platformData.id;
              const editorName = platformData.editor_name;

              if (platformId && editorName) {
                const platform = this.platforms.find(
                  (p) => p.id === platformId
                );
                if (platform && platform.emails) {
                  let email = platform.emails.find(
                    (e) => e.editor_name === editorName
                  );
                  if (email) {
                    // 编辑模式下：若回填编辑不在收藏列表，优先在收藏编辑中随机，否则平台内随机
                    const isInFavorite = favoriteEmailSet.has(
                      `${String(platformId)}_${String(email.id)}`
                    );
                    if (!isInFavorite && platform.emails.length > 0) {
                      const favoriteCandidates = platform.emails.filter((e) =>
                        favoriteEmailSet.has(
                          `${String(platformId)}_${String(e.id)}`
                        )
                      );
                      if (favoriteCandidates.length > 0) {
                        const randomFavorite =
                          favoriteCandidates[
                            Math.floor(
                              Math.random() * favoriteCandidates.length
                            )
                          ];
                        email = randomFavorite;
                      } else {
                        const randomIndex = Math.floor(
                          Math.random() * platform.emails.length
                        );
                        email = platform.emails[randomIndex];
                      }
                    }

                    const emailId = `email_${platformId}_${
                      email.id || email.editor_name
                    }`;
                    this.$set(
                      this.selectedEmailsByPlatform,
                      platformId,
                      emailId
                    );
                  }
                }
              }
            });
          }

          // 处理文件信息
          // file 是路径字符串，filename 是单独字段
          if (data.file) {
            // file 可能是字符串路径，也可能是对象（兼容处理）
            let filePath = "";
            let fileName = data.filename || data.file_name || "作品文件";

            if (typeof data.file === "string") {
              // file 是路径字符串
              filePath = data.file;
            } else if (typeof data.file === "object") {
              // 兼容处理：file 是对象
              filePath = data.file.path || data.file.file_path || "";
              fileName = data.file.filename || data.file.file_name || fileName;
            }

            if (filePath) {
              this.uploadedFiles = [
                {
                  path: filePath,
                  filename: fileName,
                },
              ];
              // 显示在文件列表中
              this.fileList = [
                {
                  name: fileName,
                  url: filePath,
                },
              ];
            }
          } else if (data.file_path) {
            // 兼容旧的数据格式（file_path 和 file_name 分开）
            this.uploadedFiles = [
              {
                path: data.file_path,
                filename: data.file_name || "作品文件",
              },
            ];
            // 如果有文件路径，显示在文件列表中
            if (data.file_name) {
              this.fileList = [
                {
                  name: data.file_name,
                  url: data.file_path,
                },
              ];
            }
          }

          // 处理多个文件的情况
          if (
            data.files &&
            Array.isArray(data.files) &&
            data.files.length > 0
          ) {
            this.uploadedFiles = data.files.map((item) => ({
              path: item.path || item.file_path,
              filename: item.filename || item.file_name || "作品文件",
            }));

            // 更新文件列表显示
            this.fileList = data.files.map((item) => ({
              name: item.filename || item.file_name,
              url: item.path || item.file_path,
            }));
          }
        }
      });
    },
    handleFileChange(file, fileList) {
      // 验证新添加的文件类型
      if (file.raw && !this.isValidFileType(file.raw)) {
        this.$message.error(
          `文件 "${file.name}" 不支持的文件类型，仅支持文档类型（如：doc、docx、pdf、txt、xls、xlsx、ppt、pptx等）`
        );
        // 从文件列表中移除不符合要求的文件
        const index = fileList.findIndex((item) => item.uid === file.uid);
        if (index > -1) {
          fileList.splice(index, 1);
          this.fileList = fileList;
        }
        return;
      }

      // 限制只能上传一个文件：如果已有文件，替换旧文件
      // 检查是否是新添加的文件（有 raw 属性且状态为 ready）
      if (file.raw && file.status === "ready") {
        // 如果之前已经有文件且不是同一个文件，清空旧文件
        const hasOldFile =
          this.fileList.length > 0 && this.fileList[0].uid !== file.uid;
        if (hasOldFile) {
          // 清空已上传的文件列表
          this.uploadedFiles = [];
        }
        // 只保留新文件（确保只有一个文件）
        this.fileList = fileList.length > 1 ? [file] : fileList;

        // 立即上传新文件
        this.uploadFile(file.raw, file.name);
      } else if (file.status === "removed") {
        // 文件被移除
        this.fileList = fileList;
        // 从已上传文件列表中移除对应的文件
        if (file.name) {
          this.uploadedFiles = this.uploadedFiles.filter(
            (item) => item.filename !== file.name
          );
        }
      } else {
        // 更新文件列表（其他状态变化）
        this.fileList = fileList;
      }
    },
    // 验证文件类型
    isValidFileType(file) {
      if (!file) {
        return false;
      }

      const fileName = file.name || "";
      const ext = fileName.split(".").pop()?.toLowerCase();

      // 允许的文档类型扩展名
      const allowedExts = [
        "doc",
        "docx", // Word文档
        "pdf", // PDF文档
        "txt", // 文本文件
        "xls",
        "xlsx", // Excel文档
        "ppt",
        "pptx", // PowerPoint文档
        "rtf", // 富文本格式
        "odt", // OpenDocument文本
        "wps", // WPS文档
        "pages", // Pages文档
      ];

      // 优先通过扩展名判断
      if (ext && allowedExts.includes(ext)) {
        return true;
      }

      // 如果文件有 MIME 类型，也进行验证
      if (file.type) {
        const fileType = file.type.toLowerCase();

        // 允许的文档 MIME 类型
        const validMimeTypes = [
          "application/msword", // .doc
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
          "application/pdf", // .pdf
          "text/plain", // .txt
          "application/vnd.ms-excel", // .xls
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
          "application/vnd.ms-powerpoint", // .ppt
          "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
          "application/rtf", // .rtf
          "application/vnd.oasis.opendocument.text", // .odt
        ];

        return validMimeTypes.includes(fileType);
      }

      return false;
    },
    // 上传文件
    uploadFile(file, filename) {
      this.uploading = true;
      const formData = new FormData();
      formData.append("file", file);
      uploadFile(formData)
        .then((response) => {
          // 保存上传后的文件信息
          if (response.data) {
            const uploadedFileInfo = {
              path: response.data.url || response.data.fullurl || response.data,
              filename:
                response.data.filename || filename || file.name || "作品文件",
            };

            // 限制只能上传一个文件，直接替换旧文件
            this.uploadedFiles = [uploadedFileInfo];

            // 自动将 filename 填充到作品名称（去掉后缀名）
            if (response.data.filename) {
              // 去掉文件后缀名
              const filenameWithoutExt = response.data.filename.replace(
                /\.[^/.]+$/,
                ""
              );
              this.form.name = filenameWithoutExt;
            }

            this.$message.success(`文件 "${filename || file.name}" 上传成功`);
          } else {
            this.$message.error(
              `文件 "${filename || file.name}" 上传失败，请重试`
            );
            // 从文件列表中移除失败的文件
            this.fileList = this.fileList.filter(
              (item) => item.name !== filename
            );
          }
          this.uploading = false;
        })
        .catch((error) => {
          this.uploading = false;
          this.$message.error(
            `文件 "${filename || file.name}" 上传失败：${
              error.message || "请重试"
            }`
          );
          // 从文件列表中移除失败的文件
          this.fileList = this.fileList.filter(
            (item) => item.name !== filename
          );
        });
    },
    handleFileRemove(file, fileList) {
      this.fileList = fileList;
      // 从已上传文件列表中移除对应的文件
      if (file.name) {
        this.uploadedFiles = this.uploadedFiles.filter(
          (item) => item.filename !== file.name
        );
      }
    },
    // 处理文件超出限制（当用户选择新文件时，自动替换旧文件）
    handleFileExceed(files, fileList) {
      // 清空旧文件
      this.fileList = [];
      this.uploadedFiles = [];

      // 添加新文件
      if (files.length > 0) {
        const newFile = files[0];
        // 验证文件类型
        if (!this.isValidFileType(newFile)) {
          this.$message.error(
            `文件 "${newFile.name}" 不支持的文件类型，仅支持文档类型（如：doc、docx、pdf、txt、xls、xlsx、ppt、pptx等）`
          );
          return;
        }

        // 添加到文件列表并上传
        const fileObj = {
          name: newFile.name,
          raw: newFile,
          uid: Date.now(),
          status: "ready",
        };
        this.fileList = [fileObj];
        this.uploadFile(newFile, newFile.name);
      }
    },
    // 处理作品字数输入，只允许数字和小数点
    handleWordsInput(value) {
      // 只保留数字和小数点
      let numericValue = value.replace(/[^\d.]/g, "");

      // 确保只有一个小数点
      const parts = numericValue.split(".");
      if (parts.length > 2) {
        // 如果有多个小数点，只保留第一个
        numericValue = parts[0] + "." + parts.slice(1).join("");
      }

      // 如果以小数点开头，在前面加0
      if (numericValue.startsWith(".")) {
        numericValue = "0" + numericValue;
      }

      this.form.words = numericValue;
    },
    toggleTag(tag) {
      // 处理对象类型的 tag
      const index = this.form.tags.findIndex((item) => {
        if (typeof item === "object" && typeof tag === "object") {
          return item.id === tag.id;
        }
        return item === tag;
      });
      if (index > -1) {
        this.form.tags.splice(index, 1);
      } else {
        this.form.tags.push(tag);
      }
    },
    // 保留旧的 togglePlatform 方法以防其他地方使用
    togglePlatform(id) {
      const index = this.selectedPlatforms.indexOf(id);
      if (index > -1) {
        this.selectedPlatforms.splice(index, 1);
      } else {
        this.selectedPlatforms.push(id);
      }
    },
    HistoricalSubmissions() {
      if (this.$router) {
        this.$router.push("/history");
      }
    },
    handleSubmit() {
      // 检查投稿次数
      if (
        this.userInfo.submission_count === 0 &&
        this.userInfo.is_member == false
      ) {
        this.$message.warning("免费投稿次数已用完");
        return;
      }

      // 表单验证
      if (!this.form.name) {
        this.$message.warning("请输入作品名称");
        return;
      }
      if (!this.form.words) {
        this.$message.warning("请输入作品字数");
        return;
      }
      if (!this.form.category) {
        this.$message.warning("请选择作品分类");
        return;
      }
      if (!this.form.readerCategory) {
        this.$message.warning("请选择读者分类");
        return;
      }
      if (!this.form.readerEmotion) {
        this.$message.warning("请选择读者情绪");
        return;
      }
      if (!this.form.style) {
        this.$message.warning("请选择作品风格");
        return;
      }
      if (this.form.tags.length === 0) {
        this.$message.warning("请至少选择一个作品类型");
        return;
      }
      if (this.selectedPlatformEmailsCount === 0) {
        this.$message.warning("请至少选择一个平台");
        return;
      }
      if (this.uploadedFiles.length === 0) {
        this.$message.warning("请至少上传一个作品文件");
        return;
      }
      // 检查是否已设置授权码
      if (!this.userInfo.auth_code || this.userInfo.auth_code === "") {
        this.emailAuthDialogVisible = true;
        this.$message.warning("请先设置邮箱授权码");
        return;
      }

      this.submitForm();
    },
    // 保存草稿（与提交使用相同的表单校验）
    handleSave() {
      // 表单验证（与 handleSubmit 保持一致）
      if (!this.form.name) {
        this.$message.warning("请输入作品名称");
        return;
      }
      if (!this.form.words) {
        this.$message.warning("请输入作品字数");
        return;
      }
      if (!this.form.category) {
        this.$message.warning("请选择作品分类");
        return;
      }
      if (!this.form.readerCategory) {
        this.$message.warning("请选择读者分类");
        return;
      }
      if (!this.form.readerEmotion) {
        this.$message.warning("请选择读者情绪");
        return;
      }
      if (!this.form.style) {
        this.$message.warning("请选择作品风格");
        return;
      }
      if (this.form.tags.length === 0) {
        this.$message.warning("请至少选择一个作品类型");
        return;
      }
      if (this.selectedPlatformEmailsCount === 0) {
        this.$message.warning("请至少选择一个平台");
        return;
      }
      if (this.uploadedFiles.length === 0) {
        this.$message.warning("请至少上传一个作品文件");
        return;
      }

      this.submitForm(true);
    },
    // 提交表单（统一的提交逻辑）
    submitForm(isSave = false) {
      // 构建 JSON 数据
      const submitData = {};

      // 作品名称
      submitData.title = this.form.name;

      // 作品字数 - 使用选中项的ID
      if (this.form.words) {
        const wordItem = this.wordOptions.find(
          (item) => (item.name || item) === this.form.words
        );
        if (wordItem && wordItem.id) {
          submitData.word_count_id = wordItem.id;
        }
      }

      // 作品分类ID - 需要找到对应的ID
      if (this.form.category) {
        const categoryItem = this.categories.find(
          (item) => (item.name || item) === this.form.category
        );
        if (categoryItem && categoryItem.id) {
          submitData.work_category_id = categoryItem.id;
        } else if (!isSave) {
          this.$message.warning("作品分类数据异常");
          return;
        }
      }

      // 读者分类ID
      if (this.form.readerCategory) {
        const readerCategoryItem = this.readerCategories.find(
          (item) => (item.name || item) === this.form.readerCategory
        );
        if (readerCategoryItem && readerCategoryItem.id) {
          submitData.reader_category_id = readerCategoryItem.id;
        } else if (!isSave) {
          this.$message.warning("读者分类数据异常");
          return;
        }
      }

      // 读者情绪ID
      if (this.form.readerEmotion) {
        const readerEmotionItem = this.readerEmotions.find(
          (item) => (item.name || item) === this.form.readerEmotion
        );
        if (readerEmotionItem && readerEmotionItem.id) {
          submitData.reader_emotion_id = readerEmotionItem.id;
        } else if (!isSave) {
          this.$message.warning("读者情绪数据异常");
          return;
        }
      }

      // 作品风格ID
      if (this.form.style) {
        const styleItem = this.styles.find(
          (item) => (item.name || item) === this.form.style
        );
        if (styleItem && styleItem.id) {
          submitData.work_style_id = styleItem.id;
        } else if (!isSave) {
          this.$message.warning("作品风格数据异常");
          return;
        }
      }

      // 作品类型ID数组
      if (this.form.tags.length > 0) {
        const workTypeIds = this.form.tags
          .map((tag) => {
            const tagItem =
              typeof tag === "object"
                ? tag
                : this.workTags.find(
                    (item) => item === tag || (item.name || item) === tag
                  );
            return tagItem && tagItem.id ? tagItem.id : null;
          })
          .filter((id) => id !== null);
        submitData.work_type_ids = workTypeIds;
      }

      // 邮件正文
      submitData.email_body = this.form.description || "";

      // 平台和邮箱信息 - 支持多平台、每平台单邮箱
      const platformsData = [];
      Object.keys(this.selectedEmailsByPlatform).forEach((platformId) => {
        const emailId = this.selectedEmailsByPlatform[platformId];
        const platform = this.platforms.find(
          (p) => String(p.id) === String(platformId)
        );
        if (!platform) {
          return;
        }
        const emailData = platform.emails?.find((e) => {
          const emailNodeId = `email_${platformId}_${e.id || e.editor_name}`;
          return emailNodeId === emailId;
        });
        if (emailData) {
          platformsData.push({
            platform_id: parseInt(platformId, 10),
            email_id: emailData.id,
            editor_name: emailData.editor_name,
          });
        }
      });

      submitData.platforms = platformsData;

      // 收藏编辑记录ID数组：优先使用收藏列表中的 item.id，确保提交正确的 favorite_editor_id
      const favoriteEditorIds = this.favoritesList
        .filter(
          (item) =>
            this.selectedFavorites[item.id] ||
            this.selectedFavorites[item.platform_email_id]
        )
        .map((item) => item.id)
        .filter((id) => id != null);
      if (favoriteEditorIds.length > 0) {
        submitData.favorite_editor_ids = favoriteEditorIds;
      }

      // 通讯录ID数组
      const addressBookIds = Object.keys(this.selectedAddressBooks)
        .filter((id) => this.selectedAddressBooks[id])
        .map((id) => parseInt(id));
      if (addressBookIds.length > 0) {
        submitData.address_book_ids = addressBookIds;
      }

      // 文件处理 - file 是路径字符串，filename 是单独字段
      if (this.uploadedFiles.length > 0) {
        // file 是文件路径（字符串）
        submitData.file = this.uploadedFiles[0].path;
        // filename 是单独字段
        submitData.filename = this.uploadedFiles[0].filename;

        // 如果有多个文件，添加文件数组
        if (this.uploadedFiles.length > 1) {
          submitData.files = this.uploadedFiles.map((item) => ({
            path: item.path,
            filename: item.filename,
          }));
        }
      } else {
        this.$message.warning("文件上传异常");
        return;
      }

      // 判断是编辑还是新增
      const id = this.$route.query.id;
      const isEdit = !!id;

      // 如果是编辑模式，添加id参数
      if (isEdit) {
        submitData.id = parseInt(id);
      }

      // 调用投稿接口
      if (isSave) {
        this.saveLoading = true;
      } else {
        this.loading = true;
      }

      const submitPromise = isEdit
        ? editSubmission(submitData)
        : addSubmission(submitData);

      submitPromise
        .then((response) => {
          if (isSave) {
            this.saveLoading = false;
          } else {
            this.loading = false;
          }

          this.$message.success(
            isSave
              ? "保存成功！"
              : isEdit
              ? "投稿编辑成功！"
              : "创建投稿成功,快去历史投稿查看投稿吧！"
          );

          // 清空表单
          this.form = {
            name: "",
            words: "",
            category: "",
            readerCategory: "",
            readerEmotion: "",
            style: "",
            tags: [],
            description: "",
          };
          this.fileList = [];
          this.uploadedFiles = [];
          this.selectedPlatforms = [];
          this.selectedEmailsByPlatform = {};
          this.selectedFavorites = {};
          this.selectedAddressBooks = {};

          // 保存草稿后直接进入历史投稿页，方便继续管理草稿
          if (isSave && this.$router) {
            this.$router.push("/history");
            return;
          }

          // 如果是编辑模式，可以选择跳转到历史记录页面或留在当前页面
          if (isEdit) {
            // 可以跳转到历史记录页面，或者留在当前页面
            // this.$router.push('/history');
          }
        })
        .catch((error) => {
          if (isSave) {
            this.saveLoading = false;
          } else {
            this.loading = false;
          }

          this.$message.error(
            error.message ||
              (isSave
                ? "保存失败，请稍后重试"
                : isEdit
                ? "投稿编辑失败，请稍后重试"
                : "投稿提交失败，请稍后重试")
          );
        });
    },
    // 打开授权邮箱弹窗
    openEmailAuthDialog() {
      this.emailAuthDialogVisible = true;
    },
    // 关闭授权邮箱弹窗
    closeEmailAuthDialog() {
      this.emailAuthDialogVisible = false;
      // 重置表单
      this.emailAuthForm = {
        email: "",
        authCode: "",
        penName: "",
      };
    },
    // 保存授权邮箱信息
    handleEmailAuthSave() {
      // 表单验证
      if (!this.emailAuthForm.authCode) {
        this.$message.warning("请输入授权码");
        return;
      }
      if (!this.emailAuthForm.penName) {
        this.$message.warning("请输入笔名");
        return;
      }

      // 调用保存接口
      this.emailAuthLoading = true;
      changeEmailCode({
        auth_code: this.emailAuthForm.authCode,
        pen_name: this.emailAuthForm.penName,
      })
        .then((response) => {
          this.emailAuthLoading = false;
          this.$message.success("保存成功");
          this.closeEmailAuthDialog();
          // 刷新用户信息，获取最新的授权码状态
          this.fetchUserInfo();
        })
        .catch((error) => {
          this.emailAuthLoading = false;
          this.$message.error(error.message || "保存失败，请稍后重试");
        });
    },
    // 点击教程链接
    handleTutorialClick() {
      // 跳转到授权教程页面
      if (this.$router) {
        this.$router.push("/email-auth-tutorial");
      }
    },
    // 处理表单字段变化的统一方法
    handleFormFieldChange(fieldName, newVal, oldVal, shouldReselect = false) {
      console.log(`字段 ${fieldName} 发生变化:`, {
        旧值: oldVal,
        新值: newVal,
      });
      // 当表单字段变化时，重新获取平台匹配列表
      this.fetchPlatformMatch(shouldReselect);
    },
  },
  watch: {
    // 侦听表单字段变化，触发平台匹配查询
    // 仅作品字数/作品分类变化时重新随机选中
    "form.words": function (newVal, oldVal) {
      this.handleFormFieldChange("作品字数", newVal, oldVal, true);
    },
    "form.category": function (newVal, oldVal) {
      this.handleFormFieldChange("作品分类", newVal, oldVal, true);
    },
    "form.readerCategory": function (newVal, oldVal) {
      this.handleFormFieldChange("读者分类", newVal, oldVal, false);
    },
    "form.readerEmotion": function (newVal, oldVal) {
      this.handleFormFieldChange("读者情绪", newVal, oldVal, false);
    },
    "form.style": function (newVal, oldVal) {
      this.handleFormFieldChange("作品风格", newVal, oldVal, false);
    },
    "form.tags": {
      handler: function (newVal, oldVal) {
        this.handleFormFieldChange("作品类型", newVal, oldVal, false);
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.quick-submit-page {
  background: linear-gradient(180deg, #fff6f8 0%, #f3f7ff 100%);
  min-height: 100vh;
  padding-bottom: 40px;
}

.submit-panel {
  max-width: 1200px;
  margin: 20px auto 0;
  border-radius: 16px 16px 0 0;
  padding: 30px 40px;
  display: flex;
  gap: 10px;
}

.submit-panel > div {
  min-width: 0;
}

.panel-left {
  border-right: 1px solid #f6f6f6;
  flex: 1;
}
.platform-container {
  flex: 1.2;
}
.upload-field {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
}

.upload-display {
  gap: 8px;
  border: 1px solid #bbb;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
  border: 1px solid #bbbbbb;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.tag-pill {
  padding: 0px 11px;
  border: 1px solid #d6dae3;
  transition: all 0.2s;
}

.tag-pill.active {
  background: #d95b75;
  color: #fff;
  border-color: #d95b75;
}

.platform-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #606266;
  min-width: 0;
}

.platform-header > .flex {
  min-width: 0;
  flex: 1;
  flex-wrap: wrap;
  gap: 8px;
}

.platform-header .el-input {
  flex: 1;
  min-width: 220px;
}

.platform-header .el-input ::v-deep .el-input__inner::placeholder {
  color: #999999;
}

.platform-header
  .el-input
  ::v-deep
  .el-input__inner::-webkit-input-placeholder {
  color: #999999;
}

.platform-header .el-input ::v-deep .el-input__inner::-moz-placeholder {
  color: #999999;
}

.platform-header .el-input ::v-deep .el-input__inner:-ms-input-placeholder {
  color: #999999;
}

/* 草稿箱入口：单独提高字号，不影响其他 text-main */
.draft-entry-link {
  font-size: 18px;
  line-height: 1.2;
  cursor: pointer;
  flex-shrink: 0;
}

.platform-list {
  border: 1px solid #ebeef5;
  border-radius: 12px;
  padding: 14px 18px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 500px;
  flex: 1;
  max-width: 400px;
}

.platform-favorites-container {
  display: flex;
  gap: 16px;
  min-width: 0;
}

.favorites-address-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 240px;
  min-width: 220px;
  flex-shrink: 0;
}

.favorites-list,
.address-book-list {
  border: 1px solid #ebeef5;
  border-radius: 12px;
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  max-height: 250px;
}

.favorites-content,
.address-book-content {
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-height: 0;
}

.favorites-header,
.address-book-header {
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.favorite-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  transition: background-color 0.2s;
  word-break: break-all;
  overflow: hidden;

  &:hover {
    background: rgba(250, 95, 109, 0.08);
  }

  &.active {
    background: rgba(250, 95, 109, 0.12);
    color: #d85a70;
  }
}

.favorite-item-content,
.address-book-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  overflow: hidden;
  min-width: 0;
}

.favorite-item-content span,
.address-book-item-content span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.address-book-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  transition: background-color 0.2s;
  word-break: break-all;
  overflow: hidden;

  &:hover {
    background: rgba(250, 95, 109, 0.08);
  }

  &.active {
    background: rgba(250, 95, 109, 0.12);
    color: #d85a70;
  }
}

.favorite-delete-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s, color 0.2s;

  &:hover {
    transform: scale(1.2);

    .delete-icon {
      color: #f56c6c;
    }
  }

  .delete-icon {
    font-size: 16px;
    color: #909399;
    transition: color 0.2s;
  }
}

.empty-favorites,
.empty-address-book {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 20px 0;
}

.loading-favorites,
.loading-address-book {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 12px 0;

  i {
    margin-right: 4px;
  }
}

.no-more-favorites,
.no-more-address-book {
  text-align: center;
  color: #ccc;
  font-size: 12px;
  padding: 12px 0;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  width: 100%;
  min-width: 0;
}

.tree-node-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.tree-node-label {
  display: inline-block;
  width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.favorite-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
  flex-shrink: 0;

  &:hover {
    transform: scale(1.2);
  }

  .favorite-icon {
    font-size: 16px;
    color: #d85a70;

    &.el-icon-star-off {
      color: #c0c4cc;
    }

    &.el-icon-star-on {
      color: #d85a70;
    }
  }
}

::v-deep .el-tree {
  background: transparent;

  .el-tree-node__content {
    height: 36px;

    &:hover {
      background: rgba(250, 95, 109, 0.08);
    }
  }

  .el-tree-node.is-disabled > .el-tree-node__content {
    cursor: default;
    color: #606266;
    font-weight: 500;
  }

  .el-tree-node:not(.is-disabled) > .el-tree-node__content {
    cursor: pointer;
  }
}

.submit-footer {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  padding: 24px 40px;
  display: flex;
  justify-content: center;
  border-radius: 0 0 16px 16px;
}

.submit-footer .el-button {
  border: none;
  width: 345px;
  height: 46px;
  background: #d85a70;
  border-radius: 57px;
}

::v-deep {
  .el-upload-dragger {
    border: none;
  }

  .submit-form .el-form-item__label {
    color: #212121;
    white-space: nowrap;
  }

  .submit-form .el-input__inner {
    width: 368px;
    height: 43px;
    line-height: 43px;
  }

  // input 和 textarea 的 placeholder 颜色
  .submit-form .el-input .el-input__inner::placeholder,
  .submit-form .el-textarea__inner::placeholder {
    color: #999999;
  }

  .submit-form .el-input .el-input__inner::-webkit-input-placeholder,
  .submit-form .el-textarea__inner::-webkit-input-placeholder {
    color: #999999;
  }

  .submit-form .el-input .el-input__inner::-moz-placeholder,
  .submit-form .el-textarea__inner::-moz-placeholder {
    color: #999999;
  }

  .submit-form .el-input .el-input__inner:-ms-input-placeholder,
  .submit-form .el-textarea__inner:-ms-input-placeholder {
    color: #999999;
  }

  // el-select 的 placeholder 颜色
  .submit-form .el-select .el-input .el-input__inner::placeholder {
    color: #212121;
  }

  .submit-form
    .el-select
    .el-input
    .el-input__inner::-webkit-input-placeholder {
    color: #212121;
  }

  .submit-form .el-select .el-input .el-input__inner::-moz-placeholder {
    color: #212121;
  }

  .submit-form .el-select .el-input .el-input__inner:-ms-input-placeholder {
    color: #212121;
  }

  .submit-form .el-select .el-input .el-select__caret,
  .submit-form .el-select .el-input .el-input__suffix .el-icon-arrow-up {
    color: #666666;
  }
}

/* 授权邮箱弹窗样式 */
::v-deep .email-auth-dialog {
  .el-dialog {
    border-radius: 12px;
    background: #f5f7fa;
  }

  .el-dialog__header {
    padding: 0;
    border-bottom: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 0 0 30px 0;
    border-top: none;
  }
}

.email-auth-title {
  font-size: 18px;
  color: #212121;
  padding: 20px 0;
  font-weight: 600;
}

.email-auth-content {
  padding: 20px 30px;
}

.email-auth-form {
  margin-bottom: 20px;
  gap: 20px;
}

.email-auth-select,
.email-auth-input {
  width: 175px;

  ::v-deep .el-input__inner {
    height: 40px;
    border-radius: 6px;
    border: 1px solid #dcdfe6;
    font-size: 14px;

    &:focus {
      border-color: #d85a70;
    }

    &::placeholder {
      font-size: 14px;
      color: #212121;
    }

    &::-webkit-input-placeholder {
      font-size: 14px;
      color: #212121;
    }

    &::-moz-placeholder {
      font-size: 14px;
      color: #212121;
    }

    &:-ms-input-placeholder {
      font-size: 14px;
      color: #212121;
    }
  }
}

.email-auth-select {
  ::v-deep .el-input__inner {
    cursor: pointer;
  }
}

.email-auth-tutorial {
  padding: 15px 0;

  .el-link {
    font-size: 14px;
    color: #d85a70;

    &:hover {
      color: #c54a60;
    }
  }
}

.email-auth-footer {
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
}

.email-auth-save-btn {
  width: 345px;
  height: 46px;
  background: #d85a70;
  border-color: #d85a70;
  color: #fff;
  border-radius: 57px;
  font-size: 16px;
  font-weight: 500;

  &:hover {
    background: #c54a60;
    border-color: #c54a60;
  }

  &:active {
    background: #b83a50;
    border-color: #b83a50;
  }
}

::v-deep {
  .el-dialog {
    height: 549px;
    border-radius: 12px;
  }
}
</style>
